import { AiChat } from "../components/ai/AiChat";

export default function Asistente() {
  return (
    <main className="mx-auto h-[calc(100dvh-4rem)] max-w-7xl px-2 py-3 sm:px-6 sm:py-6 lg:px-10" data-testid="asistente-page">
      <AiChat full />
    </main>
  );
}
